import React from "react";
import Seo from "../components/Seo";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#0B0B0D] text-zinc-200">
      <Seo
        title="Privacy Policy — CardArk"
        description="How CardArk collects, uses, and protects your data — including eBay account connections, photos you upload, and account information."
      />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <h1 data-testid="privacy-page-title" className="font-display text-4xl font-bold mb-2">Privacy Policy</h1>
        <p className="text-zinc-500 text-sm mb-10">Last updated: 2 August 2026</p>

        <div className="space-y-8 text-sm leading-relaxed text-zinc-300">
          <section>
            <h2 className="font-display text-xl font-semibold text-white mb-2">Who we are</h2>
            <p>
              CardArk is a trading card scanning, pricing and collection platform operated by
              Hidden Forge Ltd. This policy explains what data we collect when you use
              CardArk at <span className="font-mono-plex">cardark.hiddenforge.co.uk</span> and how we protect it.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-semibold text-white mb-2">Data we collect</h2>
            <ul className="list-disc pl-5 space-y-1.5">
              <li><span className="text-white">Account data</span> — your email, display name and Google account identifier when you sign in.</li>
              <li><span className="text-white">Card data</span> — photos and videos you upload, plus the identified card details we generate from them.</li>
              <li><span className="text-white">Usage data</span> — anonymous analytics on which pages and features you use.</li>
              <li><span className="text-white">Payment data</span> — handled entirely by Stripe. We never see your card number.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl font-semibold text-white mb-2">eBay account connections</h2>
            <p className="mb-2">
              If you choose to connect your eBay seller account, we store an encrypted refresh
              token so we can create draft listings on your behalf when you ask us to. We only
              use it for the eBay features you explicitly enable. You can disconnect at any
              time from Settings, which permanently deletes the token.
            </p>
            <p>
              If eBay notifies us that you have closed your eBay account, we automatically
              purge every token and identifier we hold for that account.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-semibold text-white mb-2">Photos, videos and EXIF</h2>
            <p>
              Every image you upload has GPS and camera metadata (EXIF) stripped on the server
              before storage. Photos are only used to identify and display your cards. Public
              showcase links only ever expose card photos and public fields — never your notes,
              target sale prices or matched listings.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-semibold text-white mb-2">Sharing</h2>
            <p>
              We do not sell your data. We share the minimum needed with the third-party
              services that power CardArk: Google (sign-in), Stripe (payments), Resend
              (transactional emails), OpenAI / Google Gemini (card identification vision
              models), and eBay (only if you connect your seller account).
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-semibold text-white mb-2">Your rights</h2>
            <p>
              You can request a copy of your data or ask us to delete your account at any
              time. Email <a className="text-violet-300 underline" href="mailto:hello@hiddenforge.co.uk">hello@hiddenforge.co.uk</a>.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-semibold text-white mb-2">Contact</h2>
            <p>
              Hidden Forge Ltd · <a className="text-violet-300 underline" href="mailto:hello@hiddenforge.co.uk">hello@hiddenforge.co.uk</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
